import { Pipe, PipeTransform } from '@angular/core';
import { differenceInMinutes } from 'date-fns';

import { RouteEvent } from '@commons/models/domain/RouteEvent';
import { formatMinutesToHours } from '@src/app/utils/date';

@Pipe({
  name: 'calculateDiffrenceBetweenDatesAndReturnTime',
  standalone: true
})
export class CalculateDriveTimeRoutePipe implements PipeTransform {

  transform(data: RouteEvent): string {
    const minutes = differenceInMinutes(new Date(data.En), new Date(data.St));
    return formatMinutesToHours(minutes);
  }

}
